module.exports = __webpack_public_path__ + "img/step6.b180e61a.jpg";